import { render } from "./TageList.vue?vue&type=template&id=78d8c06c&scoped=true"
import script from "./TageList.vue?vue&type=script&lang=js"
export * from "./TageList.vue?vue&type=script&lang=js"

import "./TageList.vue?vue&type=style&index=0&id=78d8c06c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d8c06c"]])

export default __exports__